module.exports = __webpack_public_path__ + "static/media/400040_01.0695a46d.png";